export default {
  "bookTrans": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Do you want to book a transport?"])},
  "yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I want to book transportation"])},
  "no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I have my own transportation"])},
  "totalPagar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total to pay"])},
  "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Loading..."])},
  "book": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Book"])},
  "noAvailableTransfer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There are not..."])},
  "select": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select an option"])}
}